export default __webpack_public_path__ + "9dd578330ed92b34cf2f11058e874e67.svg";